export default __webpack_public_path__ + "static/media/tablef.9caaeef7.png";